export const pendoEvents = {
    SECTIONDETAILS: 'SECTIONDETAILS',
    RESTRICTED_REVIEW_DETAILS: 'RESTRICTED_REVIEW_DETAILS'
}
